import { Button, Form, Input, Radio, Space, Select, Row, Col, Avatar, Switch, Tooltip, Upload, Tabs, Checkbox } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import { UserOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Link, useParams, useLoaderData, useOutletContext, useNavigate } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { RxUpdate } from "react-icons/rx";
import EventEmitter from '../../utils/eventEmitter';
import useUserAPI from '../apis/userAPI';


const UserChanges = () => {
  const {warehouses, roles, user} = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(user.name ? user.name : '');
  const [email, setEmail] = useState(user.email ? user.email : '');
  const [contactType, setUserType] = useState(user.type ? user.type: 'internal');
  const { create, update } = useUserAPI();
  
  // console.log(user);
  const onChangeName = (e) => setName(e.target.value);
  const onChangeEmail = (e) => setEmail(e.target.value);
  const toggleContactType = e => setUserType(e.target.value);

  const save = () => {
    let data = form.getFieldsValue();
    // data['name'] = name;
    // data['email'] = email;
    const seo = name.toLowerCase().replace(/ /g, '-');
    // const accessRight = {
    //   sales: data.sales,
    //   pos: data.pos,
    //   inventory: data.inventory,
    //   purchase: data.purchase,
    //   accounting: data.accounting
    // };

    const accessRight = {...data};
    const data_ = {name, email, seo, type: data.type, accessRight};
    
    create(data_, success);
    // console.log(data);
  }

  const edit = () => { 
    let data = form.getFieldsValue();
    const seo = name.toLowerCase().replace(/ /g, '-');
    // const accessRight = {
    //   sales: data.sales,
    //   pos: data.pos,
    //   inventory: data.inventory,
    //   purchase: data.purchase,
    //   accounting: data.accounting
    // };
    const accessRight = {...data};
    const data_ = {name, email, id: user.id, seo, type: data.type, accessRight};
    
    update(user.seo, data_, success);
    // console.log(data)
  };

  // useEffect(() => {
  //   EventEmitter.subscribe('user_response', data => {
  //     navigate('/app/users/'+data);
  //   });
    
  //   return () => EventEmitter.unsubscribe('user_response');
  // },[])

  // const openAddContactModal = () => {
  //   EventEmitter.dispatch('create_contact_modal_open', true);
  // }

  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className='flex justify-between'>
        <div>
          <h3 className='font-bold'>
            <Link to={'/settings/users'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Users</Link> / {params.action}
            <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={save} type='text' htmlType='button'
              disabled={user.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
          </h3>
          {user.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
        </div>
        
      </div>  
      <div className='mt-5 p-3 bg-white shadow p-3'>
        
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 8  }}
          labelWrap={true}
          initialValues={user.seo ? {...user, ...user.e_accessright} : { type: 'internal'}}
          autoComplete="off"
          variant='borderless'
        >
          <Row>
            <Col md={{ span: 11 }}>
              <FloatingLabel
                className='text-2xl text-black-900'
                variant="standard"
                placeholder="Name"
                value={name} 
                onChange={onChangeName}
              />
              <FloatingLabel
                className='text-md'
                variant="standard"
                placeholder="Email"
                value={email} 
                onChange={onChangeEmail}
              />
            </Col>
            <Col md={{ span: 3, offset: 9 }}>
              <Upload 
                name="picture"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                style={{height: '30px'}}
              >
                <Avatar icon={<UserOutlined />} />
              </Upload>
            </Col>
            <Col md={{span: 24}} className='my-5'>
              <Badge className="text-slate-800 mb-3 text-md bg-transparent	p-0 border-b-2 rounded-none">User Type</Badge>
              <Form.Item name="type" className="font-bold mb-1">
                <Radio.Group onChange={toggleContactType}>
                  <Space direction='vertical'>
                    <Radio value="internal">Internal</Radio>
                    <Radio value="public">Public</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          
          {contactType === 'internal' && 
          <Tabs
            type='card'
            items={[
              {
                key: '1',
                label: 'Access Rights',
                children: 
                <>
                  <Row>
                    <Col md={{span: 11,}} className='mb-3'>
                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">SALES</Badge>
                      <Form.Item label='Sales' name="sales" className='font-bold mb-1' >
                        <Select options={roles.map(role => ({value: role.id, label: role.name}))} className='font-normal' />
                      </Form.Item>
                      <Form.Item label='Point of Sale' name="pos" className='font-bold mb-1' >
                        <Select options={roles.map(role => ({value: role.id, label: role.name}))} className='font-normal' />
                      </Form.Item>
                    </Col>
                    <Col md={{span: 11, offset: 1}} className='mb-3'>
                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">INVENTORY</Badge>
                      <Form.Item label='Inventory' name="inventory" className='font-bold mb-1' >
                        <Select options={roles.map(role => ({value: role.id, label: role.name}))} className='font-normal' />
                      </Form.Item>
                      <Form.Item label='Purchase' name="purchase" className='font-bold mb-1' >
                        <Select options={roles.map(role => ({value: role.id, label: role.name}))} className='font-normal' />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className='mb-8'>
                    <Col md={{span: 11,}}>
                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">ACCOUNTING</Badge>
                      <Form.Item label='Accounting' name="accounting" className='font-bold mb-1' >
                        <Select options={roles.map(role => ({value: role.id, label: role.name}))} className='font-normal' />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className='mb-8'>
                    <Col md={{span: 11,}}>
                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">HUMAN RESOURCES</Badge>
                      <Form.Item label='Expenses' name="expense" className='font-bold mb-1' >
                        <Select options={roles.map(role => ({value: role.id, label: role.name}))} className='font-normal' />
                      </Form.Item>
                      <Form.Item label='Employees' name="employees" className='font-bold mb-1' >
                        <Select options={roles.map(role => ({value: role.id, label: role.name}))} className='font-normal' />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className='mb-8'>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">ADMINISTRATION</Badge>
                      <Form.Item labelCol={{md: {span: 12}}} label='Access Rights' name="admin_access_rights" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                      <Form.Item labelCol={{md: {span: 12}}} label='Settings' name="settings" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className='mb-8'>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">POS CONFIGURATION</Badge>
                      <Form.Item labelCol={{md: {span: 12}}} label='Accountant' name="pos_config_accountant" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                      <Form.Item labelCol={{md: {span: 12}}} label='Cashier' name="pos_config_cashier" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                      <Form.Item labelCol={{md: {span: 12}}} label='Manager' name="pos_config_manager" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item><Form.Item labelCol={{md: {span: 12}}} label='Senior Accountant' name="pos_config_snr_accountant" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                    </Col>
                    <Col md={{span: 11, offset: 1}}>
                      <Form.Item labelCol={{md: {span: 12}}} label='Admin' name="pos_config_admin" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                      <Form.Item labelCol={{md: {span: 12}}} label='HR' name="pos_config_hr" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                      <Form.Item labelCol={{md: {span: 12}}} label='Procurement Officer' name="pos_config_procurement_officer" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item><Form.Item labelCol={{md: {span: 12}}} label='Supervisor' name="pos_config_supervisor" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className='mb-8'>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">INVENTORY</Badge>
                      <Form.Item labelCol={{md: {span: 12}}} label='Administration' name="" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                      <Form.Item labelCol={{md: {span: 12}}} label='Operation Type Editor' name="inv_config_operation_type_editor" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                      <Form.Item labelCol={{md: {span: 12}}} label='Procurement Officer' name="inv_config_procurement_officer" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item><Form.Item labelCol={{md: {span: 12}}} label='Sales Manager' name="inv_config_sales_manager" className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox /> 
                      </Form.Item>
                    </Col>
                    <Col md={{span: 11, offset: 1}}>
                     
                    </Col>
                  </Row>
                </>
              },
              {
                key: '2',
                label: 'Preferences',
                children: 
                <Row>
                  <Col md={{span: 11}}>
                    <Form.Item label='Default Warehouse' name="default_warehouse" className='font-bold mb-1' >
                      {/* <Select options={warehouses.map(warehouse => ({value: warehouse.id, label: warehouse.name}))} className='font-normal' /> */}
                    </Form.Item>
                  </Col>
                </Row>
              }
            ]}
          />}
        </Form>
      </div>
    </div>
  )
}

export default UserChanges;